import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import McPuff from "./McPuff";
import Animation from "./Animation";
import CookieConsentOverlay from "./CookieConsentOverlay";

const AppContent = () => {
  const location = useLocation();
  const [showAnimation, setShowAnimation] = useState(location.pathname === '/');
  const [cookiesAccepted, setCookiesAccepted] = useState(false);

  useEffect(() => {
    if (location.pathname !== '/') {
      setShowAnimation(false);
      return;
    }

    const animationDuration = 2566;
    const timer = setTimeout(() => {
      setShowAnimation(false);
    }, animationDuration);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  useEffect(() => {
    const accepted = localStorage.getItem("cookiesAccepted");
    if (accepted === "true") {
      setCookiesAccepted(true);
    }
  }, []);

  const handleCookieAccept = () => {
    setCookiesAccepted(true);
    localStorage.setItem("cookiesAccepted", "true");
  };

  return (
    <div className={`app-container ${!cookiesAccepted ? "dimmed" : ""}`}>
      {!cookiesAccepted && (
        <CookieConsentOverlay onAccept={handleCookieAccept} />
      )}
      {showAnimation ? (
        <Animation />
      ) : (
        <Routes>
          <Route path="/" element={<McPuff />} />
          <Route path="/policyprivacy" element={<McPuff defaultView="privacyPolicy" />} />
          <Route path="/vapingeducativo" element={<McPuff defaultView="vapingEducativo" />} />
        </Routes>
      )}
    </div>
  );
};

const AppWithAnimation = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default AppWithAnimation;